import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            热门课程分类
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            六大学习方向，覆盖职场最需要的核心技能，总有一门适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-6 rounded-2xl bg-background-100 hover:bg-background-200 transition-all duration-300 border border-background-200/60 hover:border-primary-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-4">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{cat.name}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed mb-3">{cat.description}</p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{cat.courseCount}门课程</span>
                <span className="text-primary-600 text-sm font-medium group-hover:translate-x-1 transition-transform duration-200 whitespace-nowrap">
                  查看课程 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}